import { assert } from '@varos/util-typescript';
import { ReportingLoaderBaseConfig } from '../../base';
import { TaskListLoader } from './taskListInterface';

const POLL_INTERVAL_MS = 15000;

export function createTaskListLoader(config: ReportingLoaderBaseConfig): TaskListLoader {
    const { repository } = config;
    return {
        useLoad(context, props) {
            console.log('context', context);
            const taskQuery = repository.research.task.useFind(
                context,
                {
                    limit: 10,
                },
                {
                    suspense: true,
                    keepPreviousData: true,
                    refetchInterval(data, query) {
                        return POLL_INTERVAL_MS;
                    },
                }
            );
            assert(taskQuery.status === 'success', 'expected suspense');
            return {
                tasks: taskQuery.data,
            };
        },
    };
}
